<template>
<div class="add-device-link">
	<div v-if="aCustomVars['layout'] == 'connectscreen_4.1'">
	    <form method="POST" style="display:inline;">
	        <input type="hidden" name="iMethodId" value="41" />
	        <input type="hidden" name="bAddDevice" value="1" />
	        <button class="link-E font-E2 shadowed-text link-button" >Add a device to your connection</button>
	    </form>
	</div>
	<div v-if="aCustomVars['layout'] != 'connectscreen_4.1'">
	    <form method="POST" style="display:inline;">
	        <input type="hidden" name="iMethodId" value="41" />
	        <input type="hidden" name="bAddDevice" value="1" />
	        <button class="link-E font-E2 shadowed-text link-button" >add a device</button>
	    </form>
	    <p class="link-E shadowed-text" style="margin-bottom: 20px; display:inline-block;">to your connection</p>
	</div>
</div>
</template>

<script>

export default {
  name: "AddDeviceLink"
}

</script>

<style scoped>

</style>